import ConfigurationManager from '../../infra/configuration/ConfigurationManager';
import { ValueStoreFacade } from '../../services/JWeb';
import SessionObserver, {
  SessionEvents
} from '../../services/session/SessionObserver';
import TenantObserver, {
  TenantEvents
} from '../../services/tenantHandler/TenantObserver';
import { IUserService } from '../../services/userService';

export type SyncAuthenticationDataOnJWebValueStoreType = {
  userService: IUserService;
};

export default class SyncAuthenticationDataOnJWebValueStore {
  private _userService: IUserService;
  private _syncAuthenticationDataOnJWebValueStore: boolean;

  constructor({ userService }: SyncAuthenticationDataOnJWebValueStoreType) {
    this._userService = userService;
    const loginProps = ConfigurationManager.getProps('login');
    this._syncAuthenticationDataOnJWebValueStore =
      loginProps?.syncAuthenticationDataOnJWebValueStore;
  }

  public async init(): Promise<void> {
    if (this._syncAuthenticationDataOnJWebValueStore === true) {
      this._setAuthenticationDataOnJWebValueStore();

      TenantObserver.subscribe(
        TenantEvents.SET_TENANT,
        this._setAuthenticationDataOnJWebValueStore
      );
      SessionObserver.subscribe(
        SessionEvents.LOGGEDIN_FINISHED,
        this._setAuthenticationDataOnJWebValueStore
      );
    }
  }

  private _setAuthenticationDataOnJWebValueStore = () => {
    const authenticationData = this._userService.getAuthenticationData();
    console.log(
      '[commons-northbound-api] synching authentication data on JWeb Value Store',
      authenticationData
    );
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    ValueStoreFacade.writeKeyValueToValueStore(
      'authenticationData',
      JSON.stringify(authenticationData)
    );
  };
}
